import { getLocalizedPublicOffer } from './localized-public-offer';

export const publicOfferLib = {
  getLocalizedPublicOffer,
};
